var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creditcard-wrapper d-flex flex-column align-items-center"},[_c('form',{staticClass:"w-75 d-flex flex-column align-items-center",attrs:{"id":"payment-form"}},[_c('div',{ref:"card",staticClass:"form-control m-2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }